import { useMemo, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { parseQueryString, generateQueryString, QueryParameters } from '../lib';

export const useQueryParams = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();

  const queryParams = useMemo(() => parseQueryString(search), [search]);

  const setQueryParams = useCallback(
    (params: QueryParameters, { replace }: { replace?: boolean } = {}) => {
      const search = generateQueryString(params);
      const url = search ? `${pathname}?${search}` : pathname;
      if (replace) {
        history.replace(url);
      } else {
        history.push(url);
      }
    },
    [history, pathname]
  );

  return { queryParams, setQueryParams };
};
